import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    edition:"",
    layout: "",
    shortName: "",
    appName: "",
    statisticsUrl:"",
    taskUrl:"",
    logoType:"",
    hideScreen: false,
    homepage:"1",
    excelUpload: false,
    excelUploadModule: "",
    baseDictionary: false,
    baseDictionaryModule: "",
    cashViews: ['homepage'],
    deptTree: [],
    userDeptTree: [],
    userPostTree: [],
    userRoleTree: [],
    postList: [],
    roleList: [],
    userList: [],
    cesiumViewer: {},
    permissions:[],
    menuTree: []
  },
  mutations: {
    setEdition: (state, val) => {
      state.edition = val
    },
    setLayout: (state, val) => {
      state.layout = val
    },
    setMenuTree: (state, val) => {
      state.menuTree = val
    },
    setShortName: (state, val) => {
      state.shortName = val
    },
    setAppName: (state, val) => {
      state.appName = val
    },
    setStatisticsUrl: (state, val) => {
      state.statisticsUrl = val
    },
    setTaskUrl: (state, val) => {
      state.taskUrl = val
    },
    setUserDeptTree: (state, tree) => {
      setDisabled(tree);
      state.userDeptTree = tree;
      function setDisabled(trees) { //遍历树  获取id数组
        for (let treeOne of trees) {
          if (treeOne.type === 'dept') {
            treeOne.disabled = true;
          }
          if (treeOne.children) {  //存在子节点就递归
            setDisabled(treeOne.children);
          }
        }
      }
    },
    setUserPostTree: (state, tree) => {
      setDisabled(tree);
      state.userPostTree = tree;
      function setDisabled(trees) { //遍历树  获取id数组
        for (let treeOne of trees) {
          if (treeOne.type === 'post') {
            treeOne.disabled = true;
          }
          if (treeOne.children) {  //存在子节点就递归
            setDisabled(treeOne.children);
          }
        }
      }
    },
    setUserRoleTree: (state, tree) => {
      setDisabled(tree);
      state.userRoleTree = tree;
      function setDisabled(trees) { //遍历树  获取id数组
        for (let treeOne of trees) {
          if (treeOne.type === 'role') {
            treeOne.disabled = true;
          }
          if (treeOne.children) {  //存在子节点就递归
            setDisabled(treeOne.children);
          }
        }
      }
    },
    setDeptTree: (state, tree) => {
      state.deptTree = tree
    },
    setPostList: (state, list) => {
      state.postList = list
    },
    setRoleList: (state, list) => {
      state.roleList = list
    },
    setUserList: (state, list) => {
      state.userList = list
    },
    addCashViews: (state, view) => {
      let index = state.cashViews.indexOf(view);
      if (index === -1) {
        state.cashViews.push(view)
      }
    },
    removeCashViews: (state, view) => {
      let index = state.cashViews.indexOf(view);
      if (index > -1) {
        state.cashViews.splice(index, 1)
      }
    },
    removeAll: (state) => {
      state.cashViews = ['homepage'];
    },
    showExcelUpload: (state, module) => {
      state.excelUpload = true;
      state.excelUploadModule = module;
    },
    hideExcelUpload: (state) => {
      state.excelUpload = false;
      state.excelUploadModule = "";
    },
    showBaseDictionary: (state, module) => {
      state.baseDictionary = true;
      state.baseDictionaryModule = module;
    },
    hideBaseDictionary: (state) => {
      state.baseDictionary = false;
      state.baseDictionaryModule = "";
    },
    hasCashViews: (state, view) => {
      let index = state.cashViews.indexOf(view);
      return index > -1;
    },
    setCesiumViewer: (state, view) => {
      state.cesiumViewer = view
    },
  },
  actions: {
    // 获取用户信息
    getUserInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        getInfo().then(res => {
          const user = res.user;
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 退出系统
    logout({ commit, state }) {
      return new Promise((resolve, reject) => {
        logout(state.token).then(() => {
          commit('SET_TOKEN', '')
          commit('SET_ROLES', [])
          commit('SET_PERMISSIONS', [])
          removeToken()
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js